import { Typography, AccordionSummary, AccordionSummaryProps } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { FlexBox } from '@verifime/components';
import tokens from '@verifime/design-tokens';
import { ReactNode } from 'react';

export default function AccordionTitle({
  title,
  displayStatus,
  ...props
}: Readonly<{
  title: ReactNode;
  displayStatus: JSX.Element;
}> &
  Readonly<AccordionSummaryProps>) {
  return (
    <AccordionSummary
      sx={{ display: 'flex', justifyContent: 'space-between' }}
      expandIcon={<ExpandMoreIcon />}
      {...props}
    >
      <FlexBox
        fullWidth
        sx={{
          justifyContent: 'space-between',
          alignItems: 'center',
          marginRight: tokens.spacingXs,
        }}
      >
        {['string', 'number', 'boolean'].includes(typeof title) ? (
          <Typography variant="body1">{title}</Typography>
        ) : (
          <>{title}</>
        )}
        {displayStatus}
      </FlexBox>
    </AccordionSummary>
  );
}
